import React, { useState } from "react";
import useLocalized from "../../../Data/Localization";
import TabContainer from "../../Components/TabContainer/TabContainerModule";
import TabPanel from "../../Components/TabPanel/TabPanel";
import TopTitle from "../../Components/TopTitle/TopTitle";
import HomeContentTab from "../../Tabs/ContentEditorTabs/HomeContentTab/HomeContentTab";
import VehicleEditorTab from "../../Tabs/ContentEditorTabs/VehicleEditorTab/VehicleEditorTab";
import DriverEditorTab from "../../Tabs/ContentEditorTabs/DriverEditorTab/DriverEditorTab";
import { Prompt } from "react-router-dom";

const ContentEditorScreen = () => {

    const [showPrompt, setShowPrompt] = useState(false);

    // #region Constants

    const tabs = [
        { label: useLocalized("tab_nav_home_content") },
        { label: useLocalized("tab_nav_vehicle_content") },
        { label: useLocalized("tab_nav_driver_content") }
    ];

    // #endregion

    return (
        <>
            <Prompt
                when={showPrompt}
                message="Unsaved changes detected, continue?"
                beforeUnload={true}
            />
            <TopTitle
                title={`${useLocalized("content_editor_screen_title")}`}
                subtitle={`${useLocalized("content_editor_screen_sub_title")}`}
            />
            <TabContainer tabs={tabs} width={500}>
                <TabPanel><HomeContentTab setShowEditedAlert={(isDirty) => setShowPrompt(isDirty)} /></TabPanel>
                <TabPanel><VehicleEditorTab setShowEditedAlert={(isDirty) => setShowPrompt(isDirty)} /></TabPanel>
                <TabPanel><DriverEditorTab setShowEditedAlert={(isDirty) => setShowPrompt(isDirty)} /></TabPanel>
            </TabContainer>
        </>
    );
};

export default ContentEditorScreen;
